import React, { useMemo } from 'react';
import * as yup from 'yup';
import {
    Paper,
    Button
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import {
    getSupplierById,
    storeSupplier,
} from '../../../../../core/modules/accounting/suppliers/actions';
import { t } from '../../../../../core/i18n';
import TextField from '../../../../shared/form/generic/TextField';
import { Formik, Form } from 'formik';
import BaseFormContainer from '../../../../shared/form/BaseFormContainer';
import { useForm } from '../../../../../core/hooks/useForm';

// let's keep this out of the render to avoid useMemo
const SupplierSchema = yup.object().shape({
    name: yup.string().required(),
});

const styles = () => ({
    paper: {
        padding: 20,
    },
});

const SuppliersFormContainer = ({ classes, id, onSuccess }) => {
    const config = useMemo(
        () => ({
            fetch: () => getSupplierById(id),
            store: values => storeSupplier(values),
            defaultValue: {
                name: '',
            },
            onSuccess,
            id,
        }),
        [id, onSuccess]
    );

    const { isLoading, initialData, error, onSubmit } = useForm(config);

    return (
        <BaseFormContainer
            isLoading={isLoading}
            error={error}
            initialData={initialData}
            render={() => (
                <Paper className={classes.paper}>
                    <Formik
                        initialValues={initialData}
                        validationSchema={SupplierSchema}
                        onSubmit={onSubmit}>
                        {({ isSubmitting }) => (
                            <Form>
                                <TextField
                                    label={t('suppliers.fields.name')}
                                    name="name"
                                />
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    disabled={isSubmitting}>
                                    {t(
                                        id ? 'actions.update' : 'actions.create'
                                    )}
                                </Button>
                            </Form>
                        )}
                    </Formik>
                </Paper>
            )}
        />
    );
};

export default withStyles(styles)(SuppliersFormContainer);
